import { render, staticRenderFns } from "./detaliPageBottom.vue?vue&type=template&id=56c43b8a&scoped=true"
import script from "./detaliPageBottom.vue?vue&type=script&lang=js"
export * from "./detaliPageBottom.vue?vue&type=script&lang=js"
import style0 from "./detaliPageBottom.vue?vue&type=style&index=0&id=56c43b8a&prod&lang=scss&scoped=true"
import style1 from "./detaliPageBottom.vue?vue&type=style&index=1&id=56c43b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c43b8a",
  null
  
)

export default component.exports